import React, { useRef, forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ModalContainer = styled(({ ...rest }) => <div {...rest} />)`
    .modal-lg {
        max-width: 75vw;
    }

    .modal-body {
        padding: 0;
    }

    .deploy-h1 {
        display: none;
        visibility: hidden;
    }

    .deploy-h2 {
        font-size: 1rem;
        font-weight: 600;
        margin: 1rem 0 1.33rem 0;
    }

    .deploy-h3 {
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 1.44rem;
        margin: 0 0 0.66rem 0;
    }

    .deploy-note {
        font-weight: 600;
        margin: 1.33rem 0;
    }
`;

const BaseModal = ({ title, children, footer }, ref) => {
    const modalRef = useRef(null);
    const [modalEl, setModalEl] = useState();

    useImperativeHandle(ref, () => ({
        openModal() {
            $(modalEl).modal('show');
        },
        closeModal() {
            $(modalEl).modal('hide');
        }
    }));

    useEffect(() => {
        if (modalRef?.current) {
            setModalEl(modalRef?.current.querySelector('.modal'));
        }
    }, [modalRef, modalRef?.current]);

    return (
        <div ref={modalRef}>
            <ModalContainer id="__modal-reportType" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                <span>{title}</span>
                            </h4>
                        </div>
                        <div className="modal-body">
                            {children}
                            {footer && (
                                <div className="modal-footer">
                                    <button className="btn btn-primary" data-dismiss="modal">
                                        Close
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </ModalContainer>
        </div>
    );
};

BaseModal.propTypes = {
    title: PropTypes.string,
    footer: PropTypes.bool,
    children: PropTypes.node.isRequired
};

BaseModal.defaultProps = {
    title: '',
    footer: true
};

export default forwardRef(BaseModal);
